module.exports = __webpack_public_path__ + "img/logobrand.73f90834.png";